window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

// PAGE: Financeiro (Core & Router)
window.FazendaRP.Pages.financeiro = {
    // Shared State
    planoContasData: null,
    contasData: [],
    maquinasCache: null, // Used by Lançamentos items
    contasCache: null,   // Used by Agenda modal shortcuts
    currentAttachments: [], // State for new/edit launch attachments

    // --- MAIN RENDER ---
    render: function (container, initialTab = 'dashboard') {
        container.innerHTML = `
            <div id="financeiro-module">
                
                <!-- Submenu Interno -->
                <div class="submenu-container" style="flex-wrap: wrap;">
                    <div class="submenu-item" data-tab="dashboard"><i class="fas fa-chart-pie"></i> Dashboard</div>
                    <div class="submenu-item" data-tab="sefaz" style="position: relative;">
                        <i class="fas fa-file-invoice-dollar"></i> Sefaz
                    </div>
                    <div class="submenu-item" data-tab="inbox-bot">
                        <i class="fab fa-whatsapp"></i> Inbox Bot
                    </div>
                    <div class="submenu-item" data-tab="agenda"><i class="fas fa-calendar-alt"></i> Agenda Financeira</div>
                    <div class="submenu-item" data-tab="lancamentos"><i class="fas fa-list"></i> Lançamentos</div>
                    <div class="submenu-item" data-tab="movimentacoes"><i class="fas fa-exchange-alt"></i> Movimentações</div>
                    <div class="submenu-item" data-tab="cartao"><i class="fas fa-credit-card"></i> Cartões</div>
                    <div class="submenu-item" data-tab="galeria"><i class="fas fa-images"></i> Galeria Docs</div>
                    <div class="submenu-item" data-tab="contas"><i class="fas fa-file-invoice-dollar"></i> Contas</div>
                    <div class="submenu-item"><i class="fas fa-hand-holding-usd"></i> Dívidas</div>
                    <div class="submenu-item"><i class="fas fa-file-signature"></i> Contratos Venda</div>
                    <div class="submenu-item" data-tab="fluxo-caixa"><i class="fas fa-chart-line"></i> Fluxo Caixa</div>
                    <div class="submenu-item" data-tab="conciliacao"><i class="fas fa-search-dollar"></i> Conciliação</div>
                    <div class="submenu-item" data-tab="plano-contas"><i class="fas fa-sitemap"></i> Plano Contas</div>
                </div>

                <!-- Header de Título -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                    <h2 id="financeiro-page-title">Lançamentos</h2> 
                </div>

                <!-- Área de Conteúdo -->
                <div id="financeiro-content"></div>
            </div>
        `;

        // Gerenciar abas
        const tabs = container.querySelectorAll('.submenu-item[data-tab]');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                const pageTitle = document.getElementById('financeiro-page-title');
                if (pageTitle) pageTitle.innerText = tab.innerText;

                const tabName = tab.dataset.tab;
                this.renderTabContent(tabName);
            });
        });

        this.loadSafrasData(); // Load Safras Async
        // Check for specific deep-link or default
        this.renderTabContent(initialTab);

        // Se houver uma aba inicial que não seja dashboard, marque-a como ativa no submenu
        if (initialTab !== 'dashboard') {
            const activeTab = container.querySelector(`.submenu-item[data-tab="${initialTab}"]`);
            if (activeTab) {
                tabs.forEach(t => t.classList.remove('active'));
                activeTab.classList.add('active');
                const pageTitle = document.getElementById('financeiro-page-title');
                if (pageTitle) pageTitle.innerText = activeTab.innerText;
            }
        } else {
            const dashTab = container.querySelector('.submenu-item[data-tab="dashboard"]');
            if (dashTab) dashTab.classList.add('active');
        }
    },

    renderTabContent: function (tabName) {
        const contentContainer = document.getElementById('financeiro-content');

        if (tabName === 'dashboard') {
            if (window.FazendaRP.Pages.financeiro.dashboard) {
                window.FazendaRP.Pages.financeiro.dashboard.render(contentContainer);
            } else {
                contentContainer.innerHTML = 'Módulo Dashboard não carregado.';
            }
        } else if (tabName === 'lancamentos') {
            this.renderListaLancamentos(contentContainer);
        } else if (tabName === 'sefaz') {
            if (window.FazendaRP.Pages.financeiro.inbox) {
                window.FazendaRP.Pages.financeiro.inbox.render(contentContainer, 'sefaz');
            } else {
                contentContainer.innerHTML = 'Módulo Sefaz não carregado.';
            }
        } else if (tabName === 'inbox-bot') {
            if (window.FazendaRP.Pages.financeiro.inbox) {
                window.FazendaRP.Pages.financeiro.inbox.render(contentContainer, 'bot');
            } else {
                contentContainer.innerHTML = 'Módulo Inbox Bot não carregado.';
            }
        } else if (tabName === 'agenda') {
            this.renderAgenda(contentContainer);
        } else if (tabName === 'movimentacoes') {
            this.renderMovimentacoes(contentContainer);
        } else if (tabName === 'cartao') {
            if (window.FazendaRP.Pages.financeiro.cartao) {
                window.FazendaRP.Pages.financeiro.cartao.render(contentContainer);
            } else {
                contentContainer.innerHTML = 'Módulo Cartão não carregado.';
            }
        } else if (tabName === 'galeria') {
            this.renderGaleria(contentContainer);
        } else if (tabName === 'novo-lancamento') {
            // NOTE: State clearing moved to Menu Click or Explicit "New" Action.
            // If we are here via Edit, we MUST NOT clear state.

            const pageTitle = document.getElementById('financeiro-page-title');
            if (pageTitle) {
                // Adjust title based on context (New or Edit)
                pageTitle.innerText = (this._editingId || this._pendingEditId) ? "Editando Lançamento" : "Novo Lançamento";
            }

            const tabs = document.querySelectorAll('.submenu-item');
            tabs.forEach(t => t.classList.remove('active'));

            this.renderFormularioLancamento(contentContainer);
        } else if (tabName === 'plano-contas') {
            this.renderPlanoContas(contentContainer);
        } else if (tabName === 'contas') {
            this.renderContas(contentContainer);
        } else if (tabName === 'relatorios') {
            this.renderRelatorios(contentContainer);
        } else if (tabName === 'fluxo-caixa') {
            this.renderFluxoCaixa(contentContainer);
        } else if (tabName === 'conciliacao') {
            if (window.FazendaRP.Pages.conciliacao) {
                window.FazendaRP.Pages.conciliacao.render(contentContainer);
            } else {
                contentContainer.innerHTML = 'Módulo Conciliação não carregado.';
            }
        } else {
            contentContainer.innerHTML = `
                <div class="card" style="text-align: center; padding: 40px; color: var(--text-muted);">
                    <i class="fas fa-hard-hat fa-2x" style="margin-bottom: 15px;"></i>
                    <h3>Em desenvolvimento: ${tabName}</h3>
                    <p>Esta funcionalidade será implementada em breve.</p>
                </div>
            `;
        }
    },

    // --- SHARED HELPERS ---
    getContasOptionsHTML: function () {
        if (!this.contasData || this.contasData.length === 0) {
            return '<option value="">Nenhuma conta carregada...</option>';
        }
        let html = '<option value="">Selecione...</option>';
        html += this.contasData.map(c => `<option value="${c.id}" data-tipo="${c.tipo}">${c.nome} (${c.instituicao || '-'})</option>`).join('');
        return html;
    },

    // --- DATA LOADERS ---
    loadSafrasData: async function () {
        const { data, error } = await window.FazendaRP.supabase
            .from('safras')
            .select('id, ano, cultura, descricao')
            .order('ano', { ascending: false });

        if (error) {
            console.error("Erro ao carregar safras:", error);
            return;
        }
        this.safrasCache = data || [];

        // Refresh any existing selectors (Handling Async Race Condition)
        const selectors = document.querySelectorAll('.safra-select');
        if (selectors.length > 0) {
            const html = this.getSafrasOptionsHTML();
            selectors.forEach(sel => {
                const currentVal = sel.value;
                sel.innerHTML = html;
                if (currentVal) sel.value = currentVal; // Restore value if valid
            });
        }
    },

    getSafrasOptionsHTML: function () {
        if (!this.safrasCache) return '<option value="">Carregando...</option>';
        if (this.safrasCache.length === 0) return '<option value="">Nenhuma safra cadastrada</option>';
        return '<option value="">Selecione a Safra...</option>' +
            this.safrasCache.map(s => {
                const label = s.descricao ? s.descricao : `${s.cultura} ${s.ano}`;
                return `<option value="${s.id}">${label}</option>`;
            }).join('');
    },

    getMaquinasOptionsHTML: function () {
        if (!this.maquinasCache) return '<option value="">Carregando...</option>';
        if (this.maquinasCache.length === 0) return '<option value="">Nenhuma máquina cadastrada</option>';
        return '<option value="">Selecione...</option>' +
            this.maquinasCache.map(m => `<option value="${m.id}" data-combustiveis="${(m.combustiveis || []).join(',')}">${m.nome} ${m.placa ? '(' + m.placa + ')' : ''}</option>`).join('');
    },

    // --- SHARED UI HELPERS ---
    abrirVisualizadorAnexos: function (anexos, titulo) {
        if (!anexos || anexos.length === 0) {
            alert("Nenhum anexo disponível.");
            return;
        }

        let lista = anexos;
        if (typeof lista === 'string') {
            try { lista = JSON.parse(lista); } catch (e) { lista = []; }
        }

        if (lista.length === 0) return;

        const modalId = 'modal-visualizador-anexos';
        let modal = document.getElementById(modalId);
        if (modal) modal.remove();

        modal = document.createElement('div');
        modal.id = modalId;
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.92);display:flex;justify-content:center;align-items:center;z-index:99999; flex-direction:column;";

        let currentIndex = 0;

        const renderContent = () => {
            const file = lista[currentIndex];
            const ext = file.path.split('.').pop().toLowerCase();
            const isImg = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
            const isPdf = ['pdf'].includes(ext);

            const { data } = window.FazendaRP.supabase.storage.from('comprovantes').getPublicUrl(file.path);
            const url = data.publicUrl;

            // Preload next image if exists
            if (currentIndex < lista.length - 1) {
                const nextFile = lista[currentIndex + 1];
                const nextExt = nextFile.path.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(nextExt)) {
                    const { data: nextData } = window.FazendaRP.supabase.storage.from('comprovantes').getPublicUrl(nextFile.path);
                    new Image().src = nextData.publicUrl;
                }
            }

            if (isImg) {
                return `<img src="${url}" style="max-width:100%; max-height:85vh; border-radius:4px; box-shadow:0 0 20px rgba(0,0,0,0.5); object-fit: contain;">`;
            } else if (isPdf) {
                return `<iframe src="${url}" style="width:80vw; height:85vh; border:none; background:white; border-radius:4px;"></iframe>`;
            } else {
                return `
                   <div style="background:white; padding:40px; border-radius:8px; text-align:center; min-width: 300px;">
                       <i class="fas fa-file-download" style="font-size:3em; color:#6b7280; margin-bottom:15px;"></i>
                       <p style="color:#374151; font-weight:500; margin-bottom: 20px;">Arquivo para Download</p>
                       <a href="${url}" target="_blank" class="btn btn-primary" style="text-decoration:none; display:inline-block;">Baixar Arquivo (${ext})</a>
                   </div>
                `;
            }
        };

        const updateView = () => {
            const contentDiv = modal.querySelector('#viewer-content');
            const countDiv = modal.querySelector('#viewer-counter');
            if (contentDiv) contentDiv.innerHTML = renderContent();
            if (countDiv) countDiv.innerText = `${currentIndex + 1} / ${lista.length}`;

            // Manage arrows visibility
            const prev = modal.querySelector('#btn-prev-img');
            const next = modal.querySelector('#btn-next-img');
            if (prev) prev.style.opacity = lista.length > 1 ? '1' : '0';
            if (next) next.style.opacity = lista.length > 1 ? '1' : '0';
        };

        modal.innerHTML = `
           <div style="position:absolute; top:20px; right:20px; z-index:10001; cursor:pointer;">
               <button id="btn-close-viewer" style="background:rgba(255,255,255,0.1); color:white; border:none; border-radius:50%; width:44px; height:44px; font-size:1.5em; cursor:pointer; transition:background 0.2s; display:flex; align-items:center; justify-content:center;">
                   <i class="fas fa-times"></i>
               </button>
           </div>

            <div style="position:absolute; top:20px; left:20px; color:white; z-index:10001; text-shadow:0 1px 3px rgba(0,0,0,0.8);">
                <h3 style="margin:0; font-size:1.1em; font-weight:500; max-width: 80vw; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${titulo || 'Visualização'}</h3>
                <div id="viewer-counter" style="font-size:0.9em; opacity:0.8; margin-top: 4px;"></div>
            </div>

           <div style="display:flex; align-items:center; gap:20px; width:100%; height:100%; justify-content:center; padding:20px; box-sizing: border-box;">
               ${lista.length > 1 ? `
                   <button id="btn-prev-img" style="background:rgba(255,255,255,0.1); color:white; border:none; padding:15px; cursor:pointer; border-radius:50%; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; transition: background 0.2s;">
                       <i class="fas fa-chevron-left" style="font-size:1.5em;"></i>
                   </button>
               ` : ''}

               <div id="viewer-content" style="flex:1; display:flex; justify-content:center; align-items:center;">
                   <i class="fas fa-spinner fa-spin fa-2x" style="color:white;"></i>
               </div>

               ${lista.length > 1 ? `
                   <button id="btn-next-img" style="background:rgba(255,255,255,0.1); color:white; border:none; padding:15px; cursor:pointer; border-radius:50%; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; transition: background 0.2s;">
                       <i class="fas fa-chevron-right" style="font-size:1.5em;"></i>
                   </button>
               ` : ''}
           </div>
        `;

        document.body.appendChild(modal);

        // Prevent scroll on body
        document.body.style.overflow = 'hidden';

        updateView();

        // Close
        const close = () => {
            document.body.style.overflow = '';
            modal.remove();
        };

        modal.querySelector('#btn-close-viewer').onclick = close;

        if (lista.length > 1) {
            modal.querySelector('#btn-prev-img').onclick = (e) => {
                e.stopPropagation();
                currentIndex = (currentIndex - 1 + lista.length) % lista.length;
                updateView();
            };
            modal.querySelector('#btn-next-img').onclick = (e) => {
                e.stopPropagation();
                currentIndex = (currentIndex + 1) % lista.length;
                updateView();
            };

            // Keyboard Nav
            const keyHandler = (e) => {
                if (e.key === 'Escape') { close(); document.removeEventListener('keydown', keyHandler); }
                if (e.key === 'ArrowLeft') { currentIndex = (currentIndex - 1 + lista.length) % lista.length; updateView(); }
                if (e.key === 'ArrowRight') { currentIndex = (currentIndex + 1) % lista.length; updateView(); }
            };
            document.addEventListener('keydown', keyHandler);
        } else {
            const keyHandler = (e) => {
                if (e.key === 'Escape') { close(); document.removeEventListener('keydown', keyHandler); }
            };
            document.addEventListener('keydown', keyHandler);
        }

        modal.onclick = (e) => {
            if (e.target === modal || e.target.id === 'viewer-content') close();
        };
    },



    ensureFinancialCategories: async function () {
        // Verifica e cria categorias específicas solicitadas
        const defaults = [
            // User confirmed 2.4.1 exists.
            // Create 3.3 for Discounts
            { codigo: '3.3', nome: 'Descontos Obtidos', tipo: 'ANALITICA', natureza: 'CREDITO' }
        ];

        const { data: existing } = await window.FazendaRP.supabase
            .from('financeiro_plano_contas')
            .select('codigo');

        const existingCodes = new Set(existing ? existing.map(e => e.codigo) : []);
        const toInsert = defaults.filter(d => !existingCodes.has(d.codigo));

        if (toInsert.length > 0) {
            const { error } = await window.FazendaRP.supabase.from('financeiro_plano_contas').insert(toInsert);

            if (error) {
                console.error("Erro ao criar categoria 3.3:", error);
            } else {
                console.log('Categoria 3.3 (Descontos) criada com sucesso.');
                window.FazendaRP.Toast.show('success', 'Sistema', 'Categoria "3.3 - Descontos Obtidos" criada.');

                // Força recarregamento da lista se estiver na aba Plano de Contas
                if (window.FazendaRP.Pages.financeiro.renderPlanoContas && document.querySelector('.submenu-item[data-tab="plano-contas"].active')) {
                    window.FazendaRP.Pages.financeiro.renderPlanoContas(document.getElementById('financeiro-content'));
                }
            }
        }
    }
};

// End of Financeiro Core
// Migration scripts have been removed as the database is now populated.
